import api from '../api';
import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import { clickDownloadElement, viewDownloadElement } from '@app/helpers/download';
import { vtObjToQueryString } from '@app/helpers/objHelper';
import { IArquivo } from '@app/types/core.types';
import { objToFormData } from '@app/utils/utils';

const controllerName = 'sasProposta';

export interface SasPropostaForm {
  ordemCompraId: string;
  codigoTotvs: string;
  cnpj: string;
  razaoSocial: string;
  email: string;
  statusSasPropostaId: string;
  nomeContato: string;
  telefoneContato: string;
}

export interface SasFornecedor {
  id: string;
  email: string;
  razaoSocial: string;
  statusSasProposta: string;
  codigoTotvs: string;
  cnpj: string;
  nome: string;
  telefone1: string;
  telefone2: string;
}

export interface SasAnexoProposta {
  id: string;
  nome: string;
  local: string;
  dataInclusao: Date;
  descricaoDocumento: string;
  extensao: string;
  statusArquivoId: string;
}

export interface ISasPropostaOrdemCompraDocs {
  id: string;
  ordemCompraId: string;

  anexoSolicitacaoEsclarecimentosTecnicos: SasAnexoProposta,
  anexoRecebimentoPropostaTecnicasProponentes: SasAnexoProposta,
  anexoAprovacaoAreaRequisitante: SasAnexoProposta,
  anexoAprovacaoGerenteGeral: SasAnexoProposta,
  anexosHomologacao: SasAnexoProposta[],
  anexoEnvioConfide: SasAnexoProposta,
  anexoDesobrigrarConfide: SasAnexoProposta,
  anexoRelatorioConfide: SasAnexoProposta,
  anexoSolicitacaoAvaliacaoFinanceira: SasAnexoProposta,
  anexoEnvioAoDpc: SasAnexoProposta,
  anexoParecerDPC: SasAnexoProposta,
  anexoConfirmarSolicitacaoChancelaGJMinuta: SasAnexoProposta,
  anexoRegistroSolicitacaoChancelaGJMinuta: SasAnexoProposta,
  anexoEnvioNegociacaoMinutaContratual: SasAnexoProposta,
  anexoValidacaoEnvioNegociacaoMinutaContratual: SasAnexoProposta,
  anexoResultadoAvaliacaoFinanceira: SasAnexoProposta,
  anexoNaoEnviarComunicacaoContratada: SasAnexoProposta,
  anexoDesobrigarDDI: SasAnexoProposta,
}


export interface ISasPropostaRodadaNegociacao {
  dataSolicitacao?: Date;
  email: string;
  dataPrevisaoRetorno?: Date;
  dataRecebimentoDaProposta?: Date;
  comentario: string;
  sasCondicaoPagamentoId: string;
  valorAtualizado?: number;
  valorAntigo?: number;
  status: string;
  sasPropostaId: string;
  ordemCompraRodadaNegociacaoId: string;

  valorAtualizadoFormatado?: string;
}

export interface ISasPropostaStatusOrdemCompraFluxoProcesso {
  fluxoProcessoId: string;
  ordemCompraRodadaNegociacaoId?: string;
  status: string;
}

export interface ISasPropostaOrdemCompra {
  avaliacaoConfide: string;
  id: string;
  ordemCompraId: string;
  sasFornecedorOcId: string;
  sasFornecedorOcNome?: string;
  dataValidacao: string;
  sasFornecedor: SasFornecedor;

  statusSasPropostaNome: string;
  statusSasPropostaId: string;

  statusCartaConvite: string;
  dataStatusCartaConvite: Date;

  statusVisitaTecnica?: string;
  dataStatusVisitaTecnica?: Date;

  statusSolicitacaoEsclarecimentosTecnicos: string;
  dataStatusSolicitacaoEsclarecimentosTecnicos: Date;

  statusPropostaTecnica: string;
  dataStatusPropostaTecnica: Date;

  statusResultadoEnvioDdi: string;
  dataResultadoEnvioDdi: Date;

  dataStatusResultadoAvaliacaoTecnica: Date;
  statusResultadoAvaliacaoTecnica: any;

  dataStatusPropostaComercial: Date;
  statusPropostaComercial: string;
  dataRecebimentoPropostaComercial: Date;

  dataStatusResultadoAvaliacaoComercial: Date;
  statusResultadoAvaliacaoComercial: any;

  statusResultadoParecerTecnico: string;
  dataResultadoParecerTecnico: Date;
  comentarioResultadoParecerTecnico: string;

  dataStatusResultadoCheckDocumentacao: Date;
  statusResultadoCheckDocumentacao: any;

  dataStatusResultadoHomologacao: Date;
  statusResultadoHomologacao: any;

  resultadoCadastroResultadoAvaliacaoFinanceira: string;
  dataStatusCadastroResultadoAvaliacaoFinanceira: Date;

  compradorNome: any;
  nomeGestorTecnico?: string;
  valorPropostaComercial?: number;
  valorPropostaComercialFormatada?: string;
  numeroVencedor?: number;
  codigoTotvs?: string;

  statusResultadoEnvioConfide: any;
  dataResultadoEnvioConfide: Date;
  comentarioDesobrigrarConfide?: string;

  // dataStatusRodada: Date;
  statusRodada: any;

  dataPrevisaoRetorno: Date;
  // previsaoRetorno: any;

  ranking: number;

  statusRelatorioConfide: string;
  dataStatusRelatorioConfide: string;

  statusSolicitacaoAvaliacaoFinanceira: string;
  dataStatusSolicitacaoAvaliacaoFinanceira: string;

  statusCadastroResultadoAvaliacaoFinanceira: string;

  botoesChancela: string;

  statusConfirmarSolicitacaoChancelaGJMinuta: string;
  dataStatusConfirmarSolicitacaoChancelaGJMinuta: Date;
  dataRegistroChancelaSolicitacaoChancelaGJMinuta: Date;
  justificativaDispensarSolicitacaoChancelaGJMinuta: string;

  statusEnvioNegociacaoMinutaContratual: string;
  dataStatusEnvioNegociacaoMinutaContratual: Date;
  dataValidacaoEnvioNegociacaoMinutaContratual: Date;
  dataPrazoDevolutivaEnvioNegociacaoMinutaContratual: string;
  observacoesEnvioNegociacaoMinutaContratual: string;
  justificativaEnvioNegociacaoMinutaContratual: string;
  dataValidacaoMinutaEnvioNegociacaoMinutaContratual: string;

  envioDPC: string;
  resultadoEnvioDpc: string;
  dataResultadoEnvioDpc: Date;
  statusParecerDPC: string;
  dataStatusParecerDPC: Date;
  resultadoParecerDPC: string;
  dataResultadoParecerDPC: Date;

  dataStatusAprovarCES: Date;
  statusAprovarCES: string;
  ehVencedor: boolean;

  sasPropostaRodadaNegociacao: ISasPropostaRodadaNegociacao[];
  sasPropostaStatusOrdemCompraFluxoProcesso: ISasPropostaStatusOrdemCompraFluxoProcesso[];

  moeda: string;
}

export const createSasProposta = (form: SasPropostaForm) => api.put<any>('sasProposta', form);

export const deleteSasProposta = (id: string) =>
  api.delete<any>(`sasProposta/${id}`);

export const getPropostasOrdemCompra = (filtro: {
  ordemCompraId: string,
  isAtivas?: boolean,
  ordemCompraRodadaNegociacaoId?: string,
  fluxoProcessoId?: string;
}) => {
  var query = vtObjToQueryString(filtro);

  return api.get<ISasPropostaOrdemCompra[]>(`sasProposta/getPropostasOrdemCompra?${query}`);
};

export const getPropostasOrdemCompraDocs = (filtro: {
  ordemCompraId: string,
  sasPropostaId?: string,
  fluxoProcessoId?: string;
}) => {
  var query = vtObjToQueryString(filtro);

  return api.get<ISasPropostaOrdemCompraDocs[]>(`sasProposta/getPropostasOrdemCompraDocs?${query}`);
};

export const getDadosProposta = (id: string) => api.get<ISasPropostaOrdemCompra>(`sasProposta/dadosGerais/${id}`);

export const deleteAnexosProposta = (id: string) => api.delete(`sasProposta/deleteAnexosProposta/${id}`);

interface enviarEmailSasAnexoPropostaValues {
  ordemCompraId: string;
  fornecedorOcId: string;
  valorPropostaComercial?: number;
}

//#region ANEXOS TECNICA
// export const enviarEmailSasAnexoPropostaTecnica = (values: enviarEmailSasAnexoPropostaValues) => {
//   return api.post(`sasProposta/enviarEmailSasAnexoPropostaTecnica`, values);
// };

export const getAnexosPropostaTecnica = (ordemCompraId: string, fornecedorOcId?: string) => {
  const byFornecedor = fornecedorOcId ? 'fornecedorOcId=' + fornecedorOcId : '';
  return api.get<SasAnexoProposta[]>(`sasProposta/getAnexosPropostaTecnica/${ordemCompraId}?${byFornecedor}`);
};

//#endregion

//#region ANEXOS COMERCIAL
export const getAnexosPropostaComercial = (ordemCompraId: string, fornecedorOcId?: string) => {
  const byFornecedor = fornecedorOcId ? 'fornecedorOcId=' + fornecedorOcId : '';
  return api.get<SasAnexoProposta[]>(`sasProposta/getAnexosPropostaComercial/${ordemCompraId}?${byFornecedor}`);
};

// export const enviarEmailSasAnexoPropostaComercial = (values: enviarEmailSasAnexoPropostaValues) =>
//   api.post(`sasProposta/enviarEmailSasAnexoPropostaComercial`, values);
//#endregion

export const viewArquivo = async (id: any, nomeDoArquivo: string) => {
  var url = window.location.origin + `/api/templates/DownloadArquivo/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    viewDownloadElement(
      [resp.data],
      nomeDoArquivo,
    );
  });
};

export const downloadArquivo = (id: string, nomeDoArquivo: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/DownloadArquivo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      clickDownloadElement(
        [resp.data],
        nomeDoArquivo,
        'downloadArquivoSas'
      );
    }),
  );
};

interface SasPropostaResultado {
  sasPropostaId: string;
  comentarioAvaliacao: string;
  resultadoAvaliacao: string;
  propostaTecnica?: boolean;
  propostaComercial?: boolean;
}

interface SasCheckDocumentacaoResultado {
  sasPropostaId: string;
  comentario: string;
  resultado: string;
}

export const updatePropostaResultado = (value: SasPropostaResultado) =>
  api.put<any>(`${controllerName}/${value.sasPropostaId}`, value);

export const updateCheckDocumentacao = (value: SasCheckDocumentacaoResultado) =>
  api.put<any>(`${controllerName}/updateCheckDocumentacao/${value.sasPropostaId}`, value);

export const updateVerdorVencedor = (value: { ordemCompraId: string; sasPropostaId: string; ordem?: number; }) =>
  api.put<any>(`${controllerName}/updateVerdorVencedor/${value.sasPropostaId}`, value);

export const downloadSasAnexoPropostabyId = (id: string, fileName: string) =>
  api.downloadFile(`${controllerName}/anexos/${id}`, fileName, {}, { disableNotification: true });

export const viweSasAnexoProposta = async (id: any, nome: string) => {
  var url = window.location.origin + `/api/${controllerName}/anexos/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nome);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export interface SasConsicaoPagamento {
  id: string;
  codigo: number;
  descricao: string;
}

export const GetSasConsicaoPagamento = () =>
  api.get<SasConsicaoPagamento[]>(`${controllerName}/sasCondicaoPagamento`) || [];

export const GetSasConsicaoPagamentoOptions = () =>
  GetSasConsicaoPagamento().then(condicoes =>
    (condicoes || []).map(a => ({ text: a.descricao, value: a.id.toString() })),
  );

export const responderCartaConvite = (values: any) =>
  api.post(`${controllerName}/responderCartaConvite`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const responderVisitaTecnica = (values: any) =>
  api.post(`${controllerName}/responderVisitaTecnica`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const criarAcoesVisitaTecnicaOrdemCompra = (ordemCompraId: string, dataLimite?: string) =>
  api.post(`${controllerName}/criarAcoesVisitaTecnicaOrdemCompra`, { ordemCompraId, dataLimite });

export const responderSolicitacaoEnvioEsclarecimentosTecnicos = (values: any) =>
  api.post(`${controllerName}/responderSolicitacaoEnvioEsclarecimentosTecnicos`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

interface IEnviarEmailsConsolidacaoProps {
  ordemCompraId: string;
  destinatarios: string[];
  enviarEmail?: boolean;
  dataLimite?: string;
}

export const enviarEmailsConsolidacao = (values: IEnviarEmailsConsolidacaoProps) =>
  api.post(`${controllerName}/enviarEmailsConsolidacao`, values);

export const enviarEmailsRespostaConsolidacaoEsclarecimentos = (ordemCompraId: string, enviarEmail: boolean,fluxoProcessoId ? : string ) =>
  api.post(`${controllerName}/enviarEmailsRespostaConsolidacaoEsclarecimentos?ordemCompraId=${ordemCompraId}&enviarEmail=${enviarEmail}&fluxoProcessoId=${fluxoProcessoId}`);

export const responderRecebimentoPropostaTecnicasProponentes = (values: any) =>
  api.post(`${controllerName}/responderRecebimentoPropostaTecnicasProponentes`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const enviarEmailsPropostasTecnicas = (values: IEnviarEmailsConsolidacaoProps) =>
  api.post(`${controllerName}/enviarEmailsPropostasTecnicas`, values);

export const getComentariosParecerTecnicoRevisao = (id: string) => {
  return api.get(`${controllerName}/getComentariosParecerTecnicoRevisao/${id}`);
};

export const salvarComentarioParecerTecnicoRevisao = (values: any) => {
  return api.post(`${controllerName}/salvarComentarioParecerTecnicoRevisao`, values);
};


export interface ISasParecerTecnicoRevisao {
  id?: string,
  sasPropostaId: string,
  dataEnvioSolicitacaoRevisaoProponente?: Date,
  dataRetornoRevisaoProponente?: Date,
  dataEnvioRevisaoAreaRequisitante?: Date,
  dataRetornoParecerRevisaoProponente?: Date,
  dataRealizadaRetornoParecerRevisaoProponente?: Date,
  contemComentario: boolean;
  isShowActions: Boolean;
  aguardandoDecisaoComprador: boolean;
}

export const updateParecerTecnicoRevisao = (values: any) => {
  const form = new FormData();
  Object.keys(values).forEach(key => {
    form.append(key, values[key]);
  });

  return api.post<any>(`${controllerName}/updateParecerTecnicoRevisao`, values);
};

export const excluirParecerTecnicoRevisao = (id: string) => {
  return api.delete(`${controllerName}/excluirParecerTecnicoRevisao/${id}`);
};

export const getParecerTecnicoRevisao = (id: string) => {
  return api.get(`${controllerName}/getParecerTecnicoRevisao/${id}`);
};

export const decidirRevisaoParecerTecnicoComprador = (values: {
  ordemCompraId: string;
  sasParecerTecnicoRevisaoId: string;
  decisao: 'enviar_fornecedor' | 'enviar_gestor';
  comentario?: string;
  arquivos?: File[];
  dataLimiteResposta?: string;
}) => {
  const form = new FormData();
  form.append('ordemCompraId', values.ordemCompraId);
  form.append('sasParecerTecnicoRevisaoId', values.sasParecerTecnicoRevisaoId);
  form.append('decisao', values.decisao);
  if (values.comentario) form.append('comentario', values.comentario);
  if (values.arquivos) values.arquivos.forEach(file => form.append('arquivos', file));
  if (values.dataLimiteResposta) form.append('dataLimiteResposta', values.dataLimiteResposta);
  return api.post(`${controllerName}/decidirRevisaoParecerTecnicoComprador`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateParecerTecnicoAprovacao = (form: any) => {
  return api.post(`${controllerName}/updateParecerTecnicoAprovacao`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateDataRealConclusaoParecerTecnico = (values: any) => {
  return api.put(`${controllerName}/updateDataRealConclusaoParecerTecnico`, values);
};

export const updateHomologacao = (form: any) => {
  return api.put(`${controllerName}/updateHomologacao`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateEnvioConfide = (form: any) => {
  return api.put(`${controllerName}/updateEnvioConfide`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateDesobrigarDDI = (form: any) => {
  return api.put(`${controllerName}/updateDesobrigarDDI`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateDesobrigarConfide = (form: any) => {
  return api.put(`${controllerName}/updateDesobrigarConfide`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateEnviarDPC = (form: any) => {
  return api.put(`${controllerName}/updateEnviarDpc`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateParecerDPC = (form: any) => {
  return api.put(`${controllerName}/updateParecerDPC`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updatePropostaComercial = (form: any) => {
  return api.put(`${controllerName}/updatePropostaComercial`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const iniciarPropostaComercial = (ordemCompraId: string, dataLimite?: string) => {
  return api.post(`ordemCompra/IniciarPropostaComercial`, { ordemCompraId, dataLimite });
};

export interface ISasRodadaNegociacoes {
  sasPropostaId: string;
  dataSolicitacao: Date;
  email: string;
  dataPrevisaoRetorno: Date;
  dataRecebimentoDaProposta: Date;
  comentario: string;
  sasCondicaoPagamentoId: string;
  valorAtualizado: number;
  status: string;
}

export const updateRodadaNegociacoes = (form: any) => {
  return api.put(`${controllerName}/updateRodadaNegociacoes`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const responderRodadaNegociacoes = (sasPropostaId: string, ordemCompraRodadaNegociacaoId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/responderRodadaNegociacoes?ordemCompraRodadaNegociacaoId=${ordemCompraRodadaNegociacaoId}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getRodadaNegociacoes = (sasPropostaId: string, ordemCompraRodadaNegociacaoId?: string) => {
  var query = ordemCompraRodadaNegociacaoId ? `?ordemCompraRodadaNegociacaoId=${ordemCompraRodadaNegociacaoId}` : '';
  return api.get<ISasRodadaNegociacoes[]>(`${controllerName}/${sasPropostaId}/rodadaNegociacoes${query}`);
};

export const verificarParecerDDIDPCFinanceiro = (sasPropostaId: string) => {
  return api.get(`${controllerName}/${sasPropostaId}/verificarParecerDDIDPCFinanceiro`);
};

export const definirVencedorSasPropostaCommand = (values: any) => {
  return api.post(`${controllerName}/${values.sasPropostaId}/definirVencedorSasProposta`, objToFormData(values));
};

export const verificarNecessidadeCadastroNovaRodada = (data: {
  ordemCompraId: string;
  dataLimite?: string;
  fornecedoresSelecionados: string[];
  justificativaNaoSelecionados?: string;
  enviarEmail: boolean;
}) => {
  return api.post(`${controllerName}/verificarNecessidadeCadastroNovaRodada`, data);
};

export const notificarDemandanteCadastroNovaRodada = (ordemCompraId: string) => {
  return api.post(`${controllerName}/notificarDemandanteCadastroNovaRodada?`, { ordemCompraId });
};

export interface IOrdemCompraRodadaNegociacoes {
  statusOrdemCompraRodadaNegociacoesId: string;
  ordemCompraFluxoProcessoId: string;
  sasPropostaRodadaNegociacaoVencedoraId: string;
  sasPropostaId: string;
}

export const verificarVencedor = (ordemCompraId: string) => {
  return api.get<IOrdemCompraRodadaNegociacoes>(`${controllerName}/verificarVencedor?ordemCompraId=${ordemCompraId}`);
};


//#region SasArquivoRodadaNegociacao

export const getSasArquivoRodadaNegociacao = (sasPropostaId: string, ordemCompraRodadaNegociacaoId: string) => {
  return api.get<IArquivo[]>(`${controllerName}/${sasPropostaId}/getSasArquivoRodadaNegociacao?ordemCompraRodadaNegociacaoId=${ordemCompraRodadaNegociacaoId}`);
};

// export const postSasArquivoRodadaNegociacao = (sasPropostaId: string, form: any) => {
//   return api.post(`${controllerName}/${sasPropostaId}/postSasArquivoRodadaNegociacao`, form, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
// }


// export const putSasArquivoRodadaNegociacao = (sasPropostaId: string, form: any) => {
//   return api.put(`${controllerName}/${sasPropostaId}/putSasArquivoRodadaNegociacao`, form, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   })
// }
//#endregion

export const anexarRelatorioConfide = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/anexarRelatorioConfide`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const anexarSolicitacaoAvaliacaoFinanceira = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/anexarSolicitacaoAvaliacaoFinanceira`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const anexarCadastroResultadoAvaliacaoFinanceira = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/anexarCadastroResultadoAvaliacaoFinanceira`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const dispensarSolicitacaoChancelaGJMinuta = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/dispensarSolicitacaoChancelaGJMinuta`, form);
};

export const confirmarSolicitacaoChancelaGJMinuta = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/confirmarSolicitacaoChancelaGJMinuta`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const registroSolicitacaoChancelaGJMinuta = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/registroSolicitacaoChancelaGJMinuta`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const envioInformacoesCes = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/envioInformacoesCes`, form);
};

export const aprovarCES = (form: any) => {
  return api.post(`${controllerName}/aprovarCES`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const naoNegociarEnvioNegociacaoMinutaContratual = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/naoNegociarEnvioNegociacaoMinutaContratual`, form);
};

export const negociarEnvioNegociacaoMinutaContratual = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/negociarEnvioNegociacaoMinutaContratual`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const validarEnvioNegociacaoMinutaContratual = (sasPropostaId: string, form: any) => {
  return api.post(`${controllerName}/${sasPropostaId}/validarEnvioNegociacaoMinutaContratual`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const obrigarConfide = (ordemCompraId: string) => {
  return api.post(`${controllerName}/obrigarConfide/${ordemCompraId}`);
};

export const alterarStatusProposta = (sasPropostaId: string, statusSasPropostaId: string, justificativa: string) => {
  return api.post(`${controllerName}/${sasPropostaId}/AlterarStatusProposta`, { statusSasPropostaId, justificativa });
};

export const limparAcoesProposta = (sasPropostaId: string, ordemCompraFluxoProcessoId?: string, rodadaNegociacoesId?: string) => {
  return api.post(`${controllerName}/${sasPropostaId}/LimparAcoesProposta`, {
    ordemCompraFluxoProcessoId: ordemCompraFluxoProcessoId,
    rodadaNegociacoesId: rodadaNegociacoesId
  });
};

export const verificarNecessidadeAlteracaoModalidadeContratacao = (sasPropostaId: string) => {
  return api.get(`${controllerName}/verificarNecessidadeAlteracaoModalidadeContratacao?sasPropostaId=${sasPropostaId}`);
};

export const getComentariosNegociacaoMinuta = (sasPropostaId: string) => {
  return api.get(`${controllerName}/getComentariosNegociacaoMinuta/${sasPropostaId}`);
};

export const salvarComentarioNegociacaoMinuta = (values: any) => {
  return api.post(`${controllerName}/salvarComentarioNegociacaoMinuta`, values);
};
